export default "__VITE_ASSET__dakoWGYx__"